import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
interface AccordionProps {
  title: React.ReactNode;
  children: React.ReactNode;
  defaultOpen?: boolean;
  icon?: React.ReactNode;
  badge?: React.ReactNode;
  number?: string;
  className?: string;
  headerClassName?: string;
}
export function Accordion({
  title,
  children,
  defaultOpen = false,
  icon,
  badge,
  number,
  className = '',
  headerClassName = ''
}: AccordionProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  return <div className={`border border-white/10 rounded-xl overflow-hidden bg-white/5 ${className}`} data-id="element-17">
      <button onClick={() => setIsOpen(!isOpen)} className={`w-full flex items-center justify-between p-4 text-left transition-colors hover:bg-white/5 ${headerClassName}`} aria-expanded={isOpen} data-id="element-18">
        <div className="flex items-center gap-3 flex-1 pr-4" data-id="element-19">
          {number && <span className="text-gold font-bold" data-id="element-20">{number}</span>}
          <div className="flex flex-col gap-1" data-id="element-21">
            <div className="flex items-center gap-2" data-id="element-22">
              {title}
              {icon && <span data-id="element-23">{icon}</span>}
            </div>
            {badge && <div data-id="element-24">{badge}</div>}
          </div>
        </div>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.2
      }} className="text-white/50 flex-shrink-0" data-id="element-25">
          <ChevronDown size={20} data-id="element-26" />
        </motion.div>
      </button>
      <AnimatePresence initial={false} data-id="element-27">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} data-id="element-28">
            <div className="p-4 pt-0 border-t border-white/10 mt-2" data-id="element-29">
              <div className="pt-4" data-id="element-30">{children}</div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}